import { render, staticRenderFns } from "./CLogoIcon.vue?vue&type=template&id=5232b22c&"
import script from "./CLogoIcon.vue?vue&type=script&lang=ts&"
export * from "./CLogoIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports